// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kG4I","col":"styles_col__2gePb"};